<template>
    <a-card title="趋势分析">
        <div class="content">
            <div class="titleBox">
                <label>选择系统：</label>
                    <a-select mode="default" v-model="logstorename" style="width: 150px;" placeholder="请选择系统" @change="handleChange" show-search>
                        <a-select-option v-for="item in syslist" :key="item">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                    
                    <timeSelecter style="margin-left:20px;" :dataflag="true" @timeChanged="handleTimeChange"></timeSelecter>

                    <a-button type="primary" @click="handleSearch" style="margin-left:10px;">刷新</a-button>
            </div>
           

           <div class="dashBox">
                <div class="dashTitle">
                    <span>{{logstorename}} 异常趋势图 ({{searchTimeRange}})</span>
                    <a-select mode="default" v-model="chartPerTime" @change="handleChartPerTimeChange" style="width: 80px;float:right;margin-top:2px;" placeholder="请选择时间">
                        <a-select-option v-for="(value,name) in perTimeValue" :key="name" :value="name">
                            {{name}}
                        </a-select-option>
                    </a-select>
                </div>
                <a-empty v-if="threadData.length == 0" description="暂无数据" style="margin-top:80px;" />

                <a-spin :spinning="chartloading" >
                    <div id="systrendchart" style="width: 100%;padding-top:10px;"></div>
                </a-spin>
            </div>

            <div class="dashBox">
                <div class="dashTitle">{{logstorename}} 异常名类统计 ({{searchTimeRange}}) <a-icon :type="pieFlag ? 'table' : 'pie-chart'" class="dashIcon" @click="()=>{this.pieFlag = !this.pieFlag}" /></div>
                <a-table v-show="!pieFlag" :columns="columns" :data-source="tableData"  :pagination="pagination" :loading="tLoading" rowKey="exception" >
                    <template slot="messagetext" slot-scope="text,record">
                        <a-button type="link" :title="text" @click="handleErrorDetail(record)">{{text}}</a-button>
                    </template>
                    <template slot="operation" slot-scope="text,record">
                     <span> {{((parseInt(record.pv) / sumChartValue) * 100 ).toFixed(2) + "%"}}</span>
                    </template>

                     <template slot="otime" slot-scope="text">
                     <span> {{(new Date(text)).Format("yyyy-MM-dd hh:mm:ss")}}</span>
                    </template>

                </a-table>

                <div v-show="pieFlag"  class="pieBox">
                    <div id="syspieDiv" ></div>
                </div>

            </div>
        </div>
    </a-card>
</template>

<script>
import timeSelecter from '../logtimeselecter'

let pagination={
    pageSize:10,
}
const columns = [
    {
        title: "名称",
        dataIndex: "exception",
        scopedSlots: { customRender: 'messagetext' },
        ellipsis:true,
        width:200
    },
    {
        title: "首次发生时间",
        dataIndex: "mintime",
        scopedSlots: { customRender: 'otime' },
        width:100
    },
    {
        title: "最后发生时间",
        dataIndex: "mxtime",
        scopedSlots: { customRender: 'otime' },
        width:100
    },
    {
        title: "异常量",
        dataIndex: "pv",
        width:50,
        align:'center'
    },
    {
        title: "占比",
        dataIndex: "operation",
        scopedSlots: { customRender: 'operation' },
        width:50,
        align:'center'
    }

];

const perTimeValue = {
    '1秒':'1s',
    '1分钟':'1m',
    '5分钟':'5m',
    '10分钟':'10m',
    '1小时':'1h',
    '1天':'1d',
}
export default {
    data(){
        return {
            projectname:'',
            logstorename:'',
            syslist:[],
            threadData:[1],
            chartloading:false,
            tLoading:false,
            dateTypeTitle:9,
            dateTypeIndex:1,
            searchTimeRange:'',
            chartDate:[],
            chartValue:[],
            sumChartValue:0,
            pagination,
            columns,
            tableData:[],
            chartSys:null,
            pieSys:null,
            pieFlag:false,
            chartPerTime:'10分钟',
            perTimeValue
        }
    },
    methods:{
        handleChartPerTimeChange(){
            this.getTrendData();
        },
        handleTimeChange(tRange,timeType){
            this.searchTimeRange = tRange;
            // '1分钟':7,
            // '5分钟':8,
            // '15分钟':10,
            // '1小时':9
            switch (timeType) {
                case 11:
                    //每小时
                    this.chartPerTime = '1小时'
                    break;
                case 9:
                    //每小时
                    this.chartPerTime = '5分钟'
                    break;
                case 10:
                    //每15分钟
                    this.chartPerTime = '1分钟'
                    break;
                case 8:
                    //5分钟
                    this.chartPerTime = '1分钟'
                    break;
                case 7:
                    //1分钟
                    this.chartPerTime = '1秒'
                    break;
                default:
                    break;
            }
        },
        getAllSys(){
            let that = this;
            //判断是否是vip环境
            let hostname = window.location.host;
            if(hostname.split('.')[0] != 'fpvip'){
                that.projectname = 'app-logs-zl'
            }
            else{
                that.projectname = 'vip-app-logs-zl'
            }
            let mySysList = localStorage.getItem("monitorErrorSumData");
            if(mySysList){
                let tempSumData = JSON.parse(mySysList);
                that.syslist = tempSumData.syslist;
                //判断路由中是否有已选择系统
                let query = this.$route.query;
                if(query.sysname){
                    that.logstorename = query.sysname;
                }
                else{
                    that.logstorename = that.syslist[0];
                }
                
                that.handleSearch();
            }
            else{
                let that = this;
                let currentTime = new Date().Format('hh');
                let params = {
                    folowtype:'appcode',
                    urlparams:false
                };
                that.$store.dispatch({
                    type: "logservice/queryoverview",
                    params:params
                }).then((res)=>{
                    if(res.status == 200 && res.data.success == 1){
                        that.sumData = res.data.data;
                        that.sumData.isoverview = true;
                        that.sumData.isperhour = true;
                        that.sumData.createHour = currentTime;
                        localStorage.setItem("monitorErrorSumData",JSON.stringify(that.sumData));
                        that.getAllSys();
         
                    }
                }).catch(() => {
                });
            }
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("systrendchart").style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById("systrendchart"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
            });
        },
        handleChange(){
            this.$router.push({
                query: {
                    sysname:this.logstorename,
                    searchTimeRange:this.searchTimeRange
                }
            });
        },
        handleSearch(){
            let that = this;
            
            that.getTrendData();
            setTimeout(()=>{
                that.getDetailData();
            },500);
        },
        getTrendData(){
            let perN = this.perTimeValue[this.chartPerTime];
            let queryStr = "* | select count(1) as count,time_series(__time__, '"+perN+"', '%Y-%m-%d %H:%i:%s' ,'0') as occurtime from log where message like '%Exception:%' group by occurtime order by occurtime";
            let that = this;
            let timeRange = that.searchTimeRange.split('~');
            let starttime = (new Date(timeRange[0]).getTime())/1000;
            let endtime = (new Date(timeRange[1]).getTime())/1000;

            that.chartloading = true;
            let params = {
                projectname:that.projectname,
                logstorename:that.logstorename,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){

                    let result = res.data.data;
                    let array = result.list;
                    that.chartDate = [];
                    that.chartValue = [];
                    that.sumChartValue = 0;
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        let tempTime = "";
                        if(this.chartPerTime == '1秒'){
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm:ss');
                        }
                        else{
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm');
                        }

                        that.chartDate.push(tempTime);
                        that.chartValue.push(element.count)
                        that.sumChartValue += parseInt(element.count);
                    }

                    that.analystData();

                    
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });

        },
        getDetailData(){
            // eslint-disable-next-line no-useless-escape
            let queryStr = "* | SELECT regexp_extract(message, '[A-Za-z\.]+?Exception',0) AS exception, count(1) as pv,max(time) as mxtime,min(time) as mintime from log where message like '%Exception:%' group by  exception order by pv desc";

            let that = this;
            let timeRange = that.searchTimeRange.split('~');
            let starttime = (new Date(timeRange[0]).getTime())/1000;
            let endtime = (new Date(timeRange[1]).getTime())/1000;
            that.tLoading = true;

            let params = {
                projectname:that.projectname,
                logstorename:that.logstorename,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                paged:false,
                reverse:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.analystPie();
                }
                that.tLoading = false;
            }).catch(() => {
                that.tLoading = false;
            });
        },
     
        getDatailOption(){
            let that = this;
            let option = {
                xAxis: {
                    type: 'category',
                    data: that.chartDate.map(function (str) {
                        return str.replace(' ', '\n');
                    })
                },
                color:that.G.getChartColors(),
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: that.chartValue,
                    type: 'line',
                    smooth: true
                }]
            };
            return option;
        },
        handleErrorDetail(record){
            console.log(record);
            record.projectname = this.projectname;
            record.logstorename = this.logstorename;
            if(this.searchTimeRange){
                record.mintime = this.searchTimeRange.split('~')[0];
                record.maxtime = this.searchTimeRange.split('~')[1];
            }
            record.chartPerTime = this.chartPerTime;
            localStorage.setItem("currentSystemMsg",JSON.stringify(record))

            this.$router.push({
                path:'errordetail'
            })
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
        analystPie(){
            let that = this;
            if(that.pieSys){
                that.pieSys.clear();
            }
            if(that.tableData.length == 0){
                return
            }
            document.getElementById("syspieDiv").style.height = "360px";
            that.pieSys = that.$echarts.init(document.getElementById("syspieDiv"));
            let resultData = [];
            let array = that.tableData;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                resultData.push({
                    name:element.exception.substr(0,25),
                    value:element.pv,
                    ...element,
                })
            }
            let option = {
                title: {
                    show:false
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function(params) {
                        let res = '<div class="tooltipbox"><h2 style="color:white">' + params.data.name + '</h2> <p>异常数：'+ params.data.value +'</p><p>占比：'+ params.percent +'%</p></div>';
                        return res;
                    },
                },
                legend: {
                    orient: 'vertical',
                    right: '5px',
                    top:'bottom',
                    show:false
                },
                color:that.G.getChartColors(),
                series: [
                    {
                        name: '异常数',
                        type: 'pie',
                        radius: '50%',
                        data: resultData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            // 窗口大小自适应方案
            that.pieSys.setOption(option);
            that.pieSys.off('click');
            that.pieSys.on('click', function (params) {
                if (params.componentType === 'series') {
                    if (params.seriesType === 'pie' && params.name) {
                        that.handleErrorDetail(params.data)
                    }
                }
            });
        },
    },
    mounted(){
        this.getAllSys();
        window.addEventListener("resize", this.chartResize);

    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },
    components:{
        timeSelecter
    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
};
</script>

<style lang="less" scoped>
    .titleBox{
        width:100%;
        height: auto;
        padding:0 0 10px 0;
    }
    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
        margin-bottom: 20px;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #6d6d6d;
        font-weight: bolder;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
    cursor: default;

    }
    .dashIcon{
        color: #1890ff;
        font-size: 20px;
        margin-left: 12px;
        line-height: 38px;
        cursor: pointer;
    }
    .search_range{
        margin-left: 20px;
    }
    .pieBox{
        width:100%;
        position:relative;
    }

    #syspieDiv{
        width:360px;
        margin-left: 80px;
    }
</style>
